import { Box, Button, Paper, Typography } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { loginRedirectUrl } from "@/auth/useAuth";

const apiBase = (): string => (import.meta.env.VITE_API_URL ?? "") as string;

/** Fallback sign-in page. Most unauthenticated hits are bounced straight to the
 *  BFF /auth/login by RequireAuth; this page exists for bookmarks / explicit
 *  /login visits. Auth is OAuth 2.1 (Authorization Code + PKCE) against
 *  Keycloak, run entirely server-side — there is no password form or token
 *  paste in the browser anymore. The button is a full navigation to the BFF,
 *  which 302s to Keycloak and lands back at /auth/callback. */
export function Login() {
  const [params] = useSearchParams();
  const from = params.get("from") || "/workspace";

  const signIn = () => {
    // Preserve the intended destination so /auth/callback can route back.
    window.location.assign(`${loginRedirectUrl(apiBase())}?from=${encodeURIComponent(from)}`);
  };

  return (
    <Box sx={{ display: "grid", placeItems: "center", height: "100vh", p: 2 }}>
      <Paper sx={{ p: 4, width: 420, textAlign: "center" }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Sign in to Artie
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          You'll be redirected to your organization's sign-in.
        </Typography>
        <Button variant="contained" onClick={signIn} fullWidth>
          Sign in
        </Button>
      </Paper>
    </Box>
  );
}
